export default __webpack_public_path__ + "static/media/graphic-09.85b336be.png";